import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import ruleset from './ads.ruleset';

export default createActions({
  /**
   * Log that the user has seen an ad and when, so we can limit the number of ads they see per day.
   * Make sure you check canConsumeAds before calling this action.
   */
  consumeAd: action((state, _, api) => {
    const now = api.date.now();

    // Add seen ad timestamp
    state.seenAdTimestamps.push(now);

    // Remove old ad timestamps
    state.seenAdTimestamps = state.seenAdTimestamps.filter(
      (timestamp) => timestamp + ruleset.maxStorageInterval >= now,
    );
  }),
});
